export default __webpack_public_path__ + "static/media/Vivian.510a140f.jpg";